// extracted by mini-css-extract-plugin
export default {"title":"style_title__9cggd","rating_container":"style_rating_container__V+25J","rating":"style_rating__tm04i","overview":"style_overview__13RyX"};